// @core/api/endpoints/apikey/get_api_key_audit_logs.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyAuditLogsResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Get API key audit logs
 * Returns a paginated audit trail of all actions performed on an API key including creation, updates, revocation, and usage events. Supports filtering by action type and date range.
 */
export async function GetAPIKeyAuditLogs(
  key_id: string,
  options?: RequestOptions
): Promise<APIKeyAuditLogsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id/audit-logs`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.get<APIKeyAuditLogsResponse>(requestPath, { ...requestOptions });
}
